<template>
  <div>
    <!-- 
      拖拽后的组件效果展示逻辑
    -->
    <component
      :is="getComponent(item.type, item.component,item.platform)"
      v-model="form[item.prop]"
      v-bind="Object.assign(deepClone(item), params, { size: item.size || 'small' })"
      :placeholder="item.placeholder || getPlaceholder(item)"
      :dic="item.dicData"
    >
      <span v-if="params.html" v-html="params.html"></span>
    </component>
  </div>
</template>
<script>
export default {
  name: 'widget-form-item',
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    getComponent(type, component,plateform) {
      let KEY_COMPONENT_NAME = 'avue-';
      let result = 'input';
      if (component) return component;
      else if (type === 'array') result = 'array';
      else if (type === 'select') result = 'select';
      else if (type === 'radio') result = 'radio';
      else if (type === 'checkbox') result = 'checkbox';
      else if (['time', 'timerange'].includes(type)) result = 'time';
      else if (
        [
          'dates',
          'date',
          'datetime',
          'datetimerange',
          'daterange',
          'week',
          'month',
          'year'
        ].includes(type)
      )
        result = 'date';
      else if (type === 'cascader') result = 'cascader';
      else if (type === 'number') result = 'input-number';
      else if (type === 'password') result = 'input';
      else if (type === 'switch') result = 'switch';
      else if (type === 'rate') result = 'rate';
      else if (type === 'upload') result = 'upload';
      else if (type === 'slider') result = 'slider';
      else if (type === 'dynamic') result = 'dynamic';
      else if (type === 'icon') result = 'input-icon';
      else if (type === 'color') result = 'input-color';
      else if (type === 'map') result = 'input-map';
      // avue-input-map 当前版本avue-2.6.1不支持此功能组件.
      // 自定义调整START
      else if(plateform==='mobile')  return 'test'
      // 自定义调整END
      return KEY_COMPONENT_NAME + result;
    },
    getPlaceholder(item) {
      const label = item.label;
      if (
        [
          'select',
          'checkbox',
          'radio',
          'tree',
          'color',
          'dates',
          'date',
          'datetime',
          'datetimerange',
          'daterange',
          'week',
          'month',
          'year',
          'map',
          'icon',
        ].includes(item.type)
      )
        return `请选择 ${label}`;
      else return `请输入 ${label}`;
    },
  },
};
</script>
